import { render, staticRenderFns } from "./AdminProfitElement.vue?vue&type=template&id=572f9b78&scoped=true"
import script from "./AdminProfitElement.vue?vue&type=script&lang=js"
export * from "./AdminProfitElement.vue?vue&type=script&lang=js"
import style0 from "./AdminProfitElement.vue?vue&type=style&index=0&id=572f9b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f9b78",
  null
  
)

export default component.exports